import { Component, Input } from '@angular/core';
import * as botAnimationJson from "../../assets/animations-spinner/bot.json";
import * as cuentasAnimationJson from "../../assets/animations-spinner/cuentas.json";
import * as errorAnimationJson from "../../assets/animations-spinner/error.json";
import * as genericoAnimationJson from "../../assets/animations-spinner/generico.json";
import * as okAnimationJson from "../../assets/animations-spinner/ok.json";
import * as tarjetaAnimationJson from "../../assets/animations-spinner/tarjeta.json";
import * as userAnimationJson from "../../assets/animations-spinner/user.json";
var ANIMATIONS_DATA = {
    bot: botAnimationJson,
    cuentas: cuentasAnimationJson,
    error: errorAnimationJson,
    generico: genericoAnimationJson,
    ok: okAnimationJson,
    tarjeta: tarjetaAnimationJson,
    user: userAnimationJson
};
var BciSpinnerComponent = (function () {
    function BciSpinnerComponent() {
        this.animationSpeed = 1;
    }
    BciSpinnerComponent.prototype.ngOnInit = function () {
        this.lottieConfig = {
            animationData: ANIMATIONS_DATA[this.type] || ANIMATIONS_DATA['generico'],
            autoplay: true,
            loop: true
        };
    };
    BciSpinnerComponent.decorators = [
        { type: Component, args: [{
                    selector: 'bci-spinner',
                    template: "\n    <lottie-animation-view\n      [options]=\"lottieConfig\"\n      [width]=\"100\"\n      [height]=\"100\">\n    </lottie-animation-view>\n  "
                },] },
    ];
    /** @nocollapse */
    BciSpinnerComponent.ctorParameters = function () { return []; };
    BciSpinnerComponent.propDecorators = {
        'type': [{ type: Input },],
    };
    return BciSpinnerComponent;
}());
export { BciSpinnerComponent };
//# sourceMappingURL=bci-spinner.component.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@bci/styleline/dist/components/bci-spinner/bci-spinner.component.js
// module id = ./node_modules/@bci/styleline/dist/components/bci-spinner/bci-spinner.component.js
// module chunks = vendor